import {
  CONVERSATION_FACTS_DIMENSIONS,
  DRIFT_CHAT_CONVERSATION_CLICKED_DIMENSIONS,
  DRIFT_CHAT_END_USERS_DIMENSIONS,
  MEETINGS_USERS_DIMENSIONS,
} from 'cube/constants'

import { CubeQuery } from '@driftt/dds.reports'

export const ChatPeopleCSVDataExportQuery: CubeQuery = {
  name: 'ChatPeopleCSVDataExport',
  queryName: 'ChatPeopleCSVDataExport',
  query: {
    dimensions: [
      DRIFT_CHAT_END_USERS_DIMENSIONS.DISPLAY_NAME,
      DRIFT_CHAT_END_USERS_DIMENSIONS.EMAIL,
      MEETINGS_USERS_DIMENSIONS.END_USER_COMPANY_NAME,
      MEETINGS_USERS_DIMENSIONS.END_USER_COMPANY_EMPLOYMENT_TITLE,
      DRIFT_CHAT_END_USERS_DIMENSIONS.CQL_SCORE,
      CONVERSATION_FACTS_DIMENSIONS.CONVERSATION_UPDATED_AT,
      CONVERSATION_FACTS_DIMENSIONS.CONVERSATION_APP_URL,
    ],
  },
}

export const ChatPeopleClickCSVDataExportQuery: CubeQuery = {
  name: 'ChatPeopleClickCSVDataExport',
  queryName: 'ChatPeopleClickCSVDataExport',
  query: {
    dimensions: [
      DRIFT_CHAT_END_USERS_DIMENSIONS.DISPLAY_NAME,
      DRIFT_CHAT_END_USERS_DIMENSIONS.EMAIL,
      MEETINGS_USERS_DIMENSIONS.END_USER_COMPANY_NAME,
      MEETINGS_USERS_DIMENSIONS.END_USER_COMPANY_EMPLOYMENT_TITLE,
      DRIFT_CHAT_CONVERSATION_CLICKED_DIMENSIONS.HAS_CLICKED,
      DRIFT_CHAT_CONVERSATION_CLICKED_DIMENSIONS.CLICKED_AT,
      DRIFT_CHAT_CONVERSATION_CLICKED_DIMENSIONS.CONVERSATION_ID,
    ],
  },
}
